
import { AddVerifiedCompetencyData, VerifiedCompetencyData } from "../data/AddVerifiedCompetency.data";
import { VerifiedCompetencySubmissionData } from "../data/VerifiedCompetency.data";


export const setDropDownField = ( apiResponse ) =>
{
    const filterDropDownList = ( dropdownName ) =>
    {
        return apiResponse.reduce( ( acc, item ) =>
        {
            if ( item.dropdownName === dropdownName )
            {
                acc.push( {
                    value: item.id,
                    label: item.name,
                } );
            }
            return acc;
        }, [] );
    }

    const dropdownLists = {
        "verifiedCompetencies": filterDropDownList( "VerifiedCompetency" ),
        "status": filterDropDownList( "VerifiedCompetency Status" ),
        "verifiedCompetency": filterDropDownList( "VerifiedCompetency" ),
    };

    const formFields = [ ...VerifiedCompetencySubmissionData.formFields, ...AddVerifiedCompetencyData.formFields, ...VerifiedCompetencyData.formFields ];

    formFields.forEach( field =>
    {
        const dropdownList = dropdownLists[ field?.id ];
        if ( dropdownList )
        {
            field.fieldSetting.options = dropdownList;
        }
    } );
};

export const setFieldParameter = ( apiResponse ) =>
{
    VerifiedCompetencyData.initialState.gmpNumber = apiResponse?.gmpNumber;
    VerifiedCompetencyData.initialState.gmpName = apiResponse?.gmpName;
    VerifiedCompetencyData.initialState.verifiedCompetency = apiResponse?.verifiedCompetencyId;
    VerifiedCompetencyData.initialState.dateofCertificate = apiResponse?.dateOfCertificate;
    VerifiedCompetencyData.initialState.uploadFile = apiResponse?.competencyFileName;
    VerifiedCompetencyData.initialState.internalComments = apiResponse?.internalComments;
}
